exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._19FHN_uj_E8kwSGpX576AS{height:95vh;max-width:1122px;width:90vw}", ""]);
// Exports
exports.locals = {
	"modalContainer": "_19FHN_uj_E8kwSGpX576AS"
};